import { Route, Routes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import { ROUTES } from '../core/constants/navigation';
import HomePage from '../pages/home';
import NotFoundPage from '../pages/not-found';
import PrivacyPage from '../pages/privacy';

// Shared by the browser entry (app.jsx) and the prerender entry
// (entry-server.jsx), so the markup they produce is identical.
// Every route is public: this site has no authenticated surface
// (see docs/decisions/001-public-marketing-site.md).
export default function AppRouter() {
    return (
        <div className="app-shell">
            <Routes>
                <Route path={ROUTES.HOME} element={<HomePage />} />
                <Route path={ROUTES.PRIVACY} element={<PrivacyPage />} />
                <Route path="*" element={<NotFoundPage />} />
            </Routes>
            <Toaster position="bottom-center" />
        </div>
    );
}
